import {create} from "zustand";
import {persist} from "zustand/middleware";

// Mémorisé dans le navigateur : chaque tablette de l'atelier garde les machines de son poste.
const usePinnedMachineStore = create(persist(
    (set) => ({
        pinnedMachineIds: [],
        togglePinnedMachine: (machineId) => set((state) => ({
            pinnedMachineIds: state.pinnedMachineIds.includes(machineId)
                ? state.pinnedMachineIds.filter(id => id !== machineId)
                : [...state.pinnedMachineIds, machineId]
        })),
    }),
    {name: "print-pinned-machines"}
))

export default usePinnedMachineStore
